export const ARTICLES = {
  section1: {
    title: ["걷기에는 멀고,", "자동차를 타기엔 가까운 애매한 거리."],
    text: [
      "개인형 이동장치 (PM, Personal Mobility)는 이런 애매한 거리를 수월하게 이동할 수 있게 합니다. 대표적인 PM으로 전동킥보드, 전동휠을 들 수 있는데요. 전동킥보드는 더 이상 신기한 물건이 아니게 됐습니다. 2018년 9월 서울 강남에서 첫 선을 보인 공유 전동킥보드는 전국 곳곳에서 쉽게 마주칠 수 있게 됐죠. 한국은 PM과 일상을 함께하는 나라가 됐습니다.",
      '그런데 이 공유킥보드, 미운털 단단히 박혀버렸습니다. 우선 보행자와 갈등이 커졌습니다. 지하철역 입구나 버스 정류장, 인도 한가운데 할 것 없이 방치된 공유킥보드는 장애물입니다. 소리 없이 보도를 빠른 속도로 달리다 보행자와 부딪칠뻔하는 경우도 있습니다. 갑자기 튀어나와 사고를 유발한다며, 차량 운전자들로부터는 "킥라니(킥보드+고라니)"라는 비난을 받은 지는 꽤 되었고요.',
      "SBS 데이터저널리즘팀 마부작침은 두 가지 데이터를 통해 PM 실태를 들여다봤습니다. 우선 전국에서 벌어진 4년치 PM 관련 교통사고 현황 3142건을 전수 분석했습니다. 경찰청·도로교통공단에서 운영하는 교통사고분석시스템(TAAS)의 데이터입니다. PM사고의 양태를 보려 했습니다. 두 번째 분석 데이터는 서울시의 불법주차 공유킥보드 견인 데이터 1만 1996건입니다. 어떤 지역에서 어떤 정도로 보행권 침해가 잦은 지 확인할 수 있었습니다.",
    ],
    remark: [
      "** 교통사고분석시스템(TAAS)의 PM 사고 현황 데이터",
      "3142건에는 가해 (1686건) + 피해 (1456건)사건",
    ],
  },
  section2: {
    title: ["PM 전국 교통사고 현황"],
    text: [
      "지난 4년 동안 PM 교통사고는 7.6배 증가합니다. 보통 교통사고는 가해차종 기준으로 따지는데, 2017년 117건이던 PM이 가해차종인 사고는 지난해 897건으로 늘었습니다. 그야말로 '빠른 속도의 증가세' 입니다.",
      "이런 사고 급증세의 원인으로 두 가지로 보입니다. 우선 공유킥보드의 급증입니다. 지난 2019년 대비 2020년 사고 건수가 두 배 가까이 뛰는데, 이 시기 공유킥보드 업체와 이용도 크게 늘었습니다. 또 다른 이유는 새로운 교통수단이 도입되면 사고가 급증하는 경향입니다.",
    ],
  },
  section3: {
    text: [
      "사망자가 발생한 사고 건수도 크게 늘었습니다. PM이 가해자인 경우와 피해자인 사고 모두 말입니다. 먼저 PM이 가해자인 사고로만 보면 사망사 고는 2017년 4건에서 지난해 기준 10건으로 늘어납니다. 다만 PM 이용이 늘면서 차량에 부딪혀 PM 운전자가 숨지는 경우도 크게 늘었습니다. 2019년 4건, 지난해 7건 발생합니다.",
      "사고는 수도권, 부산, 대전 등 대도시 중심으로 집중됐습니다.  지난해 기준 전국 사고의 30%가량이 서울에서 발생했습니다. 행정 시군구 기준으로는 서울 강남구에서 가장 많은 사고가 발생합니다. 서울 강남구는 전국에서 이용량이 가장 많은 곳으로 추정되는 곳입니다.",
      "서울의 사고 지점을 통해 PM 사고를 좀 더 자세히 들여다보겠습니다.",
    ],
  },
  section4: {
    title: ["전동킥보드,", "길이 없다"],
    text: [
      "현행법상 전동킥보드 같은 PM은 인도를 달리면 안 됩니다. 자전거 도로나 도로 우편을 달려야 합니다. 그러나 도로 폭이 넓지 않은 우리 차도에서 오른편 주행은 킥보드 운전자와 차량 운전자 모두에게 사고 유발 가능성이 높습니다. 자전거 도로는 태부족합니다.",
      "넓지도 않은 보행자 겸용 자전거 도로에 전동킥보드가 끼어들면 자전거, 보행자, 전동킥보드 모두 사고 위험이 커집니다. 시속 10km 전후와 최고속력 시속 25km인 자전거와 전동킥보드의 속력 차이도 사고 위험성을 높입니다. 게다가 자전거 도로 바로 옆은 난간 없는 차도인 경우도 많습니다. 충돌이 일어난다면 차도로 넘어질 가능성도 존재합니다.",
      "앞으로 PM과 자전거에 대한 요구가 더 많아질 것으로 예측됩니다. 기술의 발전에 따라 더 새로운 유형의 개인형 탈 것들이 만들어질 가능성도 큽니다. 좁은 인도는 변화하는 우리 교통을 뒷받침할 수 없는 마지노선에 다다랐습니다. 도로 한편을 PM, 자전거, 저속 오토바이 등을 위한 공간으로 확보해 줄 필요성이 제기됩니다. 보행자와 운행자, 차량 운전자 각각의 공간을 확보해 주는 겁니다.",
    ],
  },
  section5: {
    title: ["서울시 공유전동킥보드", "불법주차 견인 지도"],
    text: [
      "서울 시내 인도 곳곳에서는 방치된 공유킥보드. 시민 보행권을 방해한다는 비난의 목소리가 높아졌습니다. 지난 7월 서울시는 조례를 개정해 불법주차된 공유킥보드를 강제견인하기 시작했습니다.",
      "지난 10월 말일까지 4달 동안 약 1만 2천 번의 견인이 있었습니다. <마부작침>이 공유킥보드 견인 데이터를 분석했습니다. 지하철역 주변의 견인이 가장 많았습니다. 지하철 역사 중심으로부터 반경 300미터 내 견인 건수는 전체의 7533건으로 전체의 62.8%를 차지했습니다. 지하철역 앞까지 타고 와서 아무 데나 세워놓고 간 경우가 많은 겁니다.",
      "눈에 띄는 건, 노인보호구역 내의 견인 통계입니다. 노인보호구역은 주로 노인복지시설, 요양시설 등의 주출입구 기준 반경 300m 이내가 지정됩니다. 차량의 주차는 피해야 하거나 금지됩니다. 서울 내 전체 노인보호구역 164곳 가운데 공유킥보드 견인이 한 번 이상 있었던 곳은 58곳으로 35.4%에 달했습니다.",
      "다만 25개 자치구 가운데 15개 구가 견인을 시행한 결과입니다. 그리고 공유킥보드 이용이 가장 많은 곳으로 추정되는 강남구가 견인에 참여하지 않아 강남의 실태를 알 수 없다는 한계가 있습니다. 공유킥보드 업계 측은 <마부작침>에 현재 서울시와 견인업체가 무리한 견인을 시행하고 있고, 이로 인해 업계의 손해가 크다고 주장했습니다.",
    ],
  },
  section6: {
    title: ["공유킥보드,", "제대로 둘 수 없나"],
    text: [
      "전동킥보드 주차 문제는 수도권만의 문제가 아닙니다. 공유킥보드 업체가 진출한 지역이 늘면서 지방에서도 전동킥보드 주차 논란이 잇따르고 있습니다. 주차할 곳이 없어서 벌어지는 일이라는 진단이 나옵니다. 현재 도로교통법이 개정되어 PM 주차구역을 지정할 수 있게 됐습니다. 서울시는 내년까지 PM 주차구역을 300곳가량 마련할 계획입니다. 하지만 지자체마다 대응 속도는 제각각입니다.",
      "지나치게 운영대수가 많아진 결과라는 진단도 나옵니다. 현재 한국의 공유킥보드 사업은 '신고제'입니다. 이렇다 보니 필요 보다 많은 공유킥보드가 존재할 수 있습니다. 빨리 수거,재배치할 운영 능력이 없는 업체들도 존재할 수 있습니다. 각 지자체의 교통상황과 이용 현황에 맞는 적절한 수준의 운영대수를 제한하는 방식이 필요하다는 목소리가 나오는 이유입니다.",
    ],
  },
  section7: {
    title: ["휘청이는 공유킥보드", "바로 잡아주려면"],
    text: [
      '"*아직도 PM법에 대한 구체적 논의가 없습니다. 심각한 문제입니다." - 국회 국토교통위원회 홍기원 의원*',
      "공유킥보드의 허가와 운영 방식부터 주차 문제까지, 이 모든 것들이 정리되려면 <PM 관련 법>이 필요합니다. 지난해 9월 국회에서 처음으로 PM 관련 제정법이 발의됐습니다. 하지만 아직도 무소식입니다. 그로부터 1년 2개월이 지나는 기간 동안, PM 교통사고는 두 배 가까이 급증했습니다. 보행 약자들의 보행권은 침해받고 있고, 이용자들의 안전은 여전히 그 자리에 머물러 있습니다.",
    ],
    remark: ["** 데이터 제공 : 국회 국토교통위원회 홍기원 의원/ 출처 : 서울시"],
  },
};

export const POPUP_ARTICLE = [
  {
    key: "article1",
    chartImgUrl:
      "https://s3.ap-northeast-2.amazonaws.com/mabu.newscloud.sbs.co.kr/pm/img/pm-graph-1.png",
    chartAlt: "graph1",
    title: "사고가 가장 많이 나는 월은?",
    text: [
      "사고 빈도는 날씨와 직결됐습니다.",
      "봄부터 늘기 시작해 10월에 정점을 찍고, 겨울부터 다시 줄어듭니다.",
      "운행자의 온몸이 노출되는 전동킥보드 특성이 반영된 겁니다.",
      "사고를 낸 운전자의 절반 넘게 2,30대였습니다.",
    ],
  },
  {
    key: "article2",
    chartImgUrl:
      "https://s3.ap-northeast-2.amazonaws.com/mabu.newscloud.sbs.co.kr/pm/img/pm-graph-2.png",
    chartAlt: "graph2",
    title: "사고가 가장 많이 발생하는 시간대는?",
    text: [
      "평일 동안 고르게 발생하던 사고는 일요일에 감소합니다.",
      "사고가 가장 많이 나는 시간대는 저녁 6시, 그 뒤를 오전 8시가 있습니다.",
      "출퇴근 시간대에 이용이 많았다는 걸 짐작할 수 있습니다.",
    ],
  },
  {
    key: "article3",
    chartImgUrl:
      "https://s3.ap-northeast-2.amazonaws.com/mabu.newscloud.sbs.co.kr/pm/img/pm-graph-3.png",
    chartAlt: "graph3",
    title: "사고가 많이 발생하는 도로 유형은?",
    text: [
      "지난해 기준, PM이 차와 부딪힌 사고가 가장 많습니다.",
      "하지만 보행 중인 사람과 부딪히는 사고가 점점 늘고 있습니다.",
      "첫해 33건, 전체 사고 대비 28%이던 보행자 충격 사고가 지난해 기준 304건, 전체 사고 대비 34%로 급증했습니다.",
    ],
  },
  {
    key: "article4",
    chartImgUrl:
      "https://s3.ap-northeast-2.amazonaws.com/mabu.newscloud.sbs.co.kr/pm/img/pm-graph-4.png",
    chartAlt: "graph4",
    title: "사고가 가장 많이 발생하는 원인은?",
    text: [
      "PM이 가해자인 사고의 원인은 안전운전 불이행이 60%가 넘습니다. 특히 50대 이상 연령대 비율이 높습니다.",
    ],
  },
  {
    key: "article5",
    chartImgUrl:
      "https://s3.ap-northeast-2.amazonaws.com/mabu.newscloud.sbs.co.kr/pm/img/pm-graph-5.png",
    chartAlt: "graph5",
    title: "PM사고 부상 정도는 어떤가?",
    text: [
      "PM 운전자가 사고를 당하는 경우 경상(57)%, 중상(35.6)% 였습니다.",
      "온몸이 노출되는 PM 특성상 순발력이 부족한 높은 연령대 운전자일수록 중상 비율이 높은 것으로 나타납니다.",
    ],
  },
];
